import {useEffect, useRef, useState} from 'react'
import {KTIcon, KTSVG} from '../../../helpers'
import {useAuth} from '../../../../app/modules/auth'
import {useSelectDeviceId, useSelectDeviceId2} from '../../core'
import {useIntl} from 'react-intl'
import {AxiosError} from 'axios'
import {
  homeListDeviceUserById,
  listDeviceUserById,
} from '../../../../app/modules/auth/core/_requests'
import {SuccessfulNotify} from '../../../../ToastMetods'

interface SearchTerms {
  [index: number]: string
}

function MyDevice() {
  //Science Lab Device
  const localSelectDevice = window.localStorage.getItem('selectDevice')
  const localSelectDevices = localSelectDevice ? JSON.parse(localSelectDevice) : null
  //Sense Miner Devices
  const localSelectDevice2 = window.localStorage.getItem('selectDevice2')
  const localSelectDevices2 = localSelectDevice2 ? JSON.parse(localSelectDevice2) : null

  const {currentUser} = useAuth()
  const {SelectDeviceId, setSelectDeviceId} = useSelectDeviceId()
  const {SelectDeviceId2, setSelectDeviceId2} = useSelectDeviceId2()

  const [deviceList, setDeviceList] = useState<any>([])
  const [deviceList2, setDeviceList2] = useState<any>([])

  const [checkboxValues, setCheckboxValues] = useState(DataControl())
  const [checkboxValues2, setCheckboxValues2] = useState(DataControl2())

  const intl = useIntl()
  const initialized = useRef(false)

  const [searchTerms, setSearchTerms] = useState<SearchTerms>({})

  const getList = async () => {
    try {
      const {data} = await listDeviceUserById(Number(currentUser?.id))
      setDeviceList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const getList2 = async () => {
    try {
      const {data} = await homeListDeviceUserById(Number(currentUser?.id))
      setDeviceList2(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  useEffect(() => {
    getList()
    getList2()
  }, [])

  //👇 Başlangıç aşamasında herhangi bir seçili cihazlarda sorun yaşanırsa listeyi temizliyoruz.
  const checkMatchingIds = async () => {
    const controlList1 = await deviceList2.find((item: any) => item.typeName === 'Science Lab')
    const controlList2 = await deviceList2.find((item: any) => item.typeName === 'Sense Miner')

    if (controlList1 && localSelectDevices.length > 0) {
      const matching = localSelectDevices.every((id: any) =>
        controlList1.devices.some((device: any) => device.deviceId === id)
      )
      if (!matching) {
        //Kayıt Eşleşmesinde Yanlışlık Var ise Listeleri Temizliyoruz
        localStorage.setItem('selectDevice', JSON.stringify([]))
        setCheckboxValues([])
      }
    }

    if (controlList2 && localSelectDevices2.length > 0) {
      const matching = localSelectDevices2.every((id: any) =>
        controlList2.devices.some((device: any) => device.deviceId === id)
      )
      if (!matching) {
        //Kayıt Eşleşmesinde Yanlışlık Var ise Listeleri Temizliyoruz
        localStorage.setItem('selectDevice2', JSON.stringify([]))
        setCheckboxValues2([])
      }
    }
  }

  const handleCheckboxChange = (index: number, id: number) => {
    const data = deviceList.filter((i: any) => i.deviceId === id)
    const deviceName = data[0].deviceThingName
    const selectedDevicesId = data[0].deviceId
    setSelectDeviceId((prevIds: number[]) => {
      const isSelected = prevIds.includes(selectedDevicesId)
      if (isSelected) {
        //👇 Eğer seçili cihaz kimliği zaten varsa, cihaz kimliğini çıkar
        SuccessfulNotify(`${deviceName} ${intl.formatMessage({id: 'DEVICE.SELECTED.REMOVE'})}`)
        //👇 `checkboxValues` durumunu da güncelliyoruz
        setCheckboxValues((prevValues: boolean[]) =>
          prevValues.map((value, i) => (i === index ? false : value))
        )
        //🤙 İlgili Cihaz Id Değerini Listeden Çıkarıp Sonucu Döndürüyoruz.
        return prevIds.filter((id) => id !== selectedDevicesId)
      } else {
        //👇 Eğer seçili cihaz kimliği yoksa, cihaz kimliğini ekle
        SuccessfulNotify(
          `${deviceName} ${intl.formatMessage({
            id: 'DEVICE.SELECTED.SUCCESS',
          })}`
        )
        //👇 `checkboxValues` durumunu da güncelliyoruz
        setCheckboxValues((prevValues: boolean[]) =>
          prevValues.map((value, i) => (i === index ? true : value))
        )
        //🤙 İlgili Cihaz Id Değerini Listeye Ekleyip Sonucu Döndürüyoruz.
        return [...prevIds, selectedDevicesId]
      }
    })
  }

  const handleCheckboxChange2 = (index: number, id: number) => {
    const data = deviceList.filter((i: any) => i.deviceId === id)
    const deviceName = data[0].deviceThingName
    const selectedDevicesId = data[0].deviceId
    setSelectDeviceId2((prevIds: number[]) => {
      const isSelected = prevIds.includes(selectedDevicesId)
      if (isSelected) {
        //👇 Eğer seçili cihaz kimliği zaten varsa, cihaz kimliğini çıkar
        SuccessfulNotify(`${deviceName} ${intl.formatMessage({id: 'DEVICE.SELECTED.REMOVE'})}`)
        //👇 `checkboxValues` durumunu da güncelliyoruz
        setCheckboxValues2((prevValues: boolean[]) =>
          prevValues.map((value, i) => (i === index ? false : value))
        )
        //🤙 İlgili Cihaz Id Değerini Listeden Çıkarıp Sonucu Döndürüyoruz.
        return prevIds.filter((id) => id !== selectedDevicesId)
      } else {
        //👇 Eğer seçili cihaz kimliği yoksa, cihaz kimliğini ekle
        SuccessfulNotify(
          `${deviceName} ${intl.formatMessage({
            id: 'DEVICE.SELECTED.SUCCESS',
          })}`
        )
        //👇 `checkboxValues` durumunu da güncelliyoruz
        setCheckboxValues2((prevValues: boolean[]) =>
          prevValues.map((value, i) => (i === index ? true : value))
        )
        //🤙 İlgili Cihaz Id Değerini Listeye Ekleyip Sonucu Döndürüyoruz.
        return [...prevIds, selectedDevicesId]
      }
    })
  }

  //👇 SelectDeviceId değiştiğinde local alandaki selectDevice a seçili cihaz bilgisini aktarıyoruz.
  useEffect(() => {
    if (initialized.current) {
      checkMatchingIds()
      window.localStorage.setItem('selectDevice', JSON.stringify(SelectDeviceId))
    } else {
      initialized.current = true
    }
  }, [SelectDeviceId])

  //👇 SelectDeviceId2 değiştiğinde local alandaki selectDevice2 a seçili cihaz bilgisini aktarıyoruz.
  useEffect(() => {
    if (initialized.current) {
      checkMatchingIds()
      window.localStorage.setItem('selectDevice2', JSON.stringify(SelectDeviceId2))
    } else {
      initialized.current = true
    }
  }, [SelectDeviceId2])

  //👇 Başlangıçta Seçili Cihaz Bilgisini CheckBoxValues ve SelectDeviceId e aktarıyoruz.
  useEffect(() => {
    const firstData = DataControl()
    setCheckboxValues(firstData)
    setSelectDeviceId(localSelectDevices ? localSelectDevices : [])
  }, [deviceList2])

  //👇 Anlık SelectDeviceId değiştiğinde CheckBoxValues değişiyor.
  useEffect(() => {
    setCheckboxValues(() => {
      const scienceLabItem = deviceList2.find((item: any) => item.typeName === 'Science Lab')

      if (scienceLabItem) {
        return scienceLabItem.devices.map((item: any) =>
          (SelectDeviceId || []).includes(item.deviceId)
        )
      }

      return []
    })
  }, [SelectDeviceId])

  //👇 Scince Lab Başlangıçta Seçili Cihaz Bilgisini Döndürüyoruz.
  function DataControl() {
    const scienceLabItem = deviceList2.find((item: any) => item.typeName === 'Science Lab')

    if (scienceLabItem) {
      return scienceLabItem.devices.map((item: any) =>
        (localSelectDevices || []).includes(item.deviceId)
      )
    }

    return []
  }

  //👇 Başlangıçta Seçili Cihaz Bilgisini CheckBoxValues ve SelectDeviceId e aktarıyoruz.
  useEffect(() => {
    const firstData = DataControl2()
    setCheckboxValues2(firstData)
    setSelectDeviceId2(localSelectDevices2 ? localSelectDevices2 : [])
  }, [deviceList2])

  //👇 Anlık SelectDeviceId2 değiştiğinde CheckBoxValues2 değişiyor.
  useEffect(() => {
    setCheckboxValues2(() => {
      const scienceLabItem = deviceList2.find((item: any) => item.typeName === 'Sense Miner')

      if (scienceLabItem) {
        return scienceLabItem.devices.map((item: any) =>
          (SelectDeviceId2 || []).includes(item.deviceId)
        )
      }

      return []
    })
  }, [SelectDeviceId2])

  //👇 Sense Miner Başlangıçta Seçili Cihaz Bilgisini Döndürüyoruz.
  function DataControl2() {
    const scienceLabItem = deviceList2.find((item: any) => item.typeName === 'Sense Miner')

    if (scienceLabItem) {
      return scienceLabItem.devices.map((item: any) =>
        (localSelectDevices2 || []).includes(item.deviceId)
      )
    }

    return []
  }

  const getRandomColorClass = (index: number) => {
    const colors = ['bg-primary', 'bg-success', 'bg-danger', 'bg-warning', 'bg-info']
    const colorIndex = index % colors.length
    return colors[colorIndex]
  }

  // 👇 Search Metin Güncelleme
  const handleSearchTermChange = (index: number, value: string) => {
    setSearchTerms({...searchTerms, [index]: value})
  }

  // 👇  Arama İşlemleri
  const keys = ['deviceThingName']

  const search = (list: any, index: number) => {
    let term = searchTerms[index]
    if (term) {
      return list.filter((item: any) =>
        keys.some((key) => item[key].toLocaleLowerCase().includes(term.toLocaleLowerCase()))
      )
    } else {
      return list
    }
  }

  return (
    <div
      id='kt_mydevice'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='mydevice'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'100%', 'lg': '900px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_mydevice_toggle'
      data-kt-drawer-close='#kt_mydevice_close'
    >
      <div className='card shadow-none rounded-0' style={{width: '100%'}}>
        <div className='card-header' id='kt_mydevice_header'>
          <h3 className='card-title fw-bolder text-dark'>
            {' '}
            {intl.formatMessage({id: 'SLIDEMENU.MYDEVICE'})}
          </h3>

          <div className='card-toolbar'>
            <button
              type='button'
              className='btn btn-sm btn-icon btn-active-light-primary me-n5'
              id='kt_mydevice_close'
            >
              <KTIcon iconName='cross' className='fs-1' />
            </button>
          </div>
        </div>

        <div className='card-body position-relative bg-light' id='kt_category_body'>
          <div
            id='kt_category_scroll'
            className='position-relative scroll-y '
            data-kt-scroll='true'
            data-kt-scroll-height='auto'
            data-kt-scroll-wrappers='#kt_category_body'
            data-kt-scroll-dependencies='#kt_category_header'
            data-kt-scroll-offset='5px'
            style={{overflowX: 'hidden'}}
          >
            {/* */}
            <div className='row g-5'>
              {deviceList2.map((i: any, index: number) => {
                return (
                  <div key={index} className='col-xl-6'>
                    <div className='card card-flush h-md-100'>
                      <div className='card-header'>
                        <div className='card-title'>
                          {i.typeName === 'Science Lab' ? (
                            <i className='las la-vial me-2 fs-2 text-primary' />
                          ) : (
                            <i className='las la-mobile me-2 fs-2 text-success' />
                          )}
                          {i.typeName}
                        </div>
                      </div>
                      {/* 👇  Search Bar 👇 */}
                      <div className='d-flex align-items-center px-5 mx-2  mb-3'>
                        <div
                          className={`d-flex bg-light align-items-center rounded position-relative square border border-secondary w-100 `}
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen021.svg'
                            className={`svg-icon-1 position-absolute ms-5 text-secondary`}
                          />
                          <input
                            id={`search${index}`}
                            type='text'
                            className='form-control form-control-solid ps-14'
                            placeholder={`Search ${i.typeName}`}
                            value={searchTerms[index] || ''}
                            onChange={(e) => handleSearchTermChange(index, e.target.value)}
                          />
                        </div>
                      </div>
                      {/* 👆  Search Bar 👆 */}
                      <div className='card-body pt-0'>
                        <div className='table-responsive'>
                          <table className='table table-row-dashed align-middle gs-0 gy-4 my-0'>
                            <tbody>
                              {search(i.devices, index).map((item: any, index: number) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <div className='d-flex align-items-center'>
                                        <div className='symbol symbol-40px me-4'>
                                          <div
                                            className={`symbol-label fs-2 fw-semibold ${getRandomColorClass(
                                              index
                                            )} text-inverse-danger`}
                                          >
                                            {item.deviceThingName.charAt(0).toUpperCase()}
                                          </div>
                                        </div>
                                        <div className='d-flex justify-content-start flex-column'>
                                          <a
                                            href='#'
                                            className='text-dark fw-bold text-hover-primary mb-1 fs-6'
                                          >
                                            {item.deviceThingName}
                                          </a>
                                          <span className='text-muted fw-semibold d-block fs-7'></span>
                                        </div>
                                      </div>
                                    </td>

                                    <td className='text-end'>
                                      <div className='form-check'>
                                        <input
                                          className='form-check-input'
                                          type='checkbox'
                                          name={`myDeviceRadio${i.typeName}`}
                                          id={`myDeviceRadio${i.typeName}`}
                                          onClick={(e) => e.stopPropagation()}
                                          checked={
                                            i.typeName === 'Science Lab'
                                              ? /*!!checkboxValues[index]*/ SelectDeviceId.includes(
                                                  item.deviceId
                                                )
                                              : i.typeName === 'Sense Miner'
                                              ? /*!!checkboxValues2[index]*/ SelectDeviceId2.includes(
                                                  item.deviceId
                                                )
                                              : false
                                          }
                                          onChange={() =>
                                            i.typeName === 'Science Lab'
                                              ? handleCheckboxChange(index, item.deviceId)
                                              : i.typeName === 'Sense Miner'
                                              ? handleCheckboxChange2(index, item.deviceId)
                                              : null
                                          }
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}

              {/* }
              {deviceList2.map((i: any, index: number) => (
                <div key={index} className='col-lg-4 '>
                  <h5 className='ms-2 text-primary text-start'>{i.typeName}</h5>
                  <div className='row'>
                    {i.devices.map((item: any, index: number) => (
                      <div className='col-lg-6 m-3' key={item.deviceId}>
                        <div className='form-check'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            name={`myDeviceRadio${i.typeName}`}
                            id={`myDeviceRadio${i.typeName}`}
                            onClick={(e) => e.stopPropagation()}
                            checked={
                              i.typeName === 'Science Lab'
                                ? !!checkboxValues[index]
                                : i.typeName === 'Sense Miner'
                                ? !!checkboxValues2[index]
                                : false
                            }
                            onChange={() =>
                              i.typeName === 'Science Lab'
                                ? handleCheckboxChange(index, item.deviceId)
                                : i.typeName === 'Sense Miner'
                                ? handleCheckboxChange2(index, item.deviceId)
                                : null
                            }
                          />

                          <label
                            className='form-check-label'
                            htmlFor={`myDeviceRadio${i.typeName}`}
                          >
                            {item.deviceThingName}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
                   {/* */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MyDevice
